import { LeadColumn, LeadData } from "@/pages/leads/types";

/**
 * The leads column the API groups its aggregations by, per group option the
 * table offers. Company name is linked rather than stored, so it groups on the
 * company id the name resolves from.
 */
const AGGREGATION_FIELD_BY_GROUP_FIELD: Record<string, keyof LeadData> = {
  [LeadColumn.STATUS]: LeadColumn.STATUS as keyof LeadData,
  [LeadColumn.SOURCE]: LeadColumn.SOURCE as keyof LeadData,
  [LeadColumn.SDR_OWNER]: LeadColumn.SDR_OWNER as keyof LeadData,
  [LeadColumn.AE_OWNER]: LeadColumn.AE_OWNER as keyof LeadData,
  [LeadColumn.COMPANY_NAME]: "companyId"
};

export const leadGroupAggregationField = (groupField?: string) =>
  groupField ? AGGREGATION_FIELD_BY_GROUP_FIELD[groupField] : undefined;
